(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  // Carousel functionality (mobile only for square grids)
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    const progressEl = carousel.querySelector('[data-carousel-progress]');
    const progressBar = carousel.querySelector('[data-carousel-progress-bar]');
    const items = Array.from(track.querySelectorAll('[data-archive-item]'));
    const gap = 8;

    if (!track || items.length === 0) return;

    let currentOffset = 0;
    let startX = 0;
    let isDragging = false;
    let isCarouselActive = false;

    const getItemWidth = () => items[0]?.offsetWidth || 0;
    const getMaxOffset = () => {
      const itemWidth = getItemWidth();
      const visibleItems = 2;
      return Math.max(0, (items.length - visibleItems) * (itemWidth + gap));
    };

    const updateCarousel = (offset) => {
      if (!isCarouselActive) return;
      const maxOffset = getMaxOffset();
      currentOffset = Math.max(0, Math.min(offset, maxOffset));
      track.style.transform = `translateX(-${currentOffset}px)`;

      if (progressBar && maxOffset > 0) {
        const progress = (currentOffset / maxOffset) * 100;
        progressBar.style.width = `${Math.min(100, progress + (100 / items.length))}%`;
      }
    };

    const enableCarousel = () => {
      isCarouselActive = true;
      if (progressEl) progressEl.hidden = false;
      updateCarousel(0);
    };

    const disableCarousel = () => {
      isCarouselActive = false;
      currentOffset = 0;
      track.style.transform = '';
      if (progressEl) progressEl.hidden = true;
    };

    const onTouchStart = (e) => {
      if (!isCarouselActive) return;
      startX = e.touches[0].clientX;
      isDragging = true;
      track.style.transition = 'none';
    };

    const onTouchMove = (e) => {
      if (!isDragging || !isCarouselActive) return;
      const deltaX = startX - e.touches[0].clientX;
      updateCarousel(currentOffset + deltaX);
      startX = e.touches[0].clientX;
    };

    const onTouchEnd = () => {
      if (!isCarouselActive) return;
      isDragging = false;
      track.style.transition = '';
      const itemWidth = getItemWidth();
      const snapIndex = Math.round(currentOffset / (itemWidth + gap));
      updateCarousel(snapIndex * (itemWidth + gap));
    };

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: true });
    track.addEventListener('touchend', onTouchEnd);

    // Handle resize
    const checkMode = () => {
      if (mobileQuery.matches) {
        enableCarousel();
      } else {
        disableCarousel();
      }
    };

    mobileQuery.addEventListener('change', checkMode);
    checkMode();
  });

  // Click to open detail
  document.querySelectorAll('[data-archive-item]').forEach(item => {
    item.addEventListener('click', () => {
      const section = item.closest('[data-archive-section]');
      const dataScript = section?.querySelector('[data-archive-section-data]');
      if (!dataScript) return;

      const data = JSON.parse(dataScript.textContent);
      const index = parseInt(item.dataset.index, 10);

      window.dispatchEvent(new CustomEvent('archive:open-detail', {
        detail: { ...data, activeIndex: index }
      }));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["archive-video-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Autoplay hosted videos when visible (muted, looping)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('[data-video]');
      if (!video) return;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('[data-video-wrapper]').forEach(wrapper => {
    const video = wrapper.querySelector('[data-video]');
    if (!video) return;
    video.setAttribute('playsinline', '');
    video.muted = true;
    observer.observe(wrapper);
  });
});

  } catch(e) { console.error(e); }
})();
})();
